import { Dayjs, ManipulateType, OpUnitType } from 'dayjs';
import { Dispatch, SetStateAction } from 'react';

export type DateRangePickerProps = {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setStartDate: Dispatch<SetStateAction<Dayjs | null>>;
  setEndDate: Dispatch<SetStateAction<Dayjs | null>>;
  disabled?: boolean;
  buttonClasses?: string;
  shortcuts?: DateShortcuts[];
};

export enum DateShortcuts {
  'Last30Days' = 'last-30-days',
  'Last60Days' = 'last-60-days',
  'Last7Days' = 'last-7-days',
  ThisYear = 'thisYear',
}

export type ShortcutType = 'this' | 'last';
export type Shortcut<T extends ShortcutType> = {
  type: T;
  unit: T extends 'last' ? ManipulateType : OpUnitType;
} & (T extends 'last' ? { value: number } : {});
